import MultiDropdown, { TMultiDropdown } from '../../../../../../shared/Inputs/MultiDropdownInput'
import { IEquipmentModel } from '../../equipmentModels.types.ts'
import { useRecoilValue } from 'recoil'
import equipmentModelsAtom from '../../equipmentModels.atom.ts'
import { CSSProperties, useMemo } from 'react'
import { IOption } from '@/types/global.ts'

interface IProps {
  selected: IEquipmentModel['id'][]
  onSelect: (modelIds: IEquipmentModel['id'][], name: string) => void
  name: string
  title?: string
  type?: TMultiDropdown
  panelStyle?: CSSProperties
}

const EquipmentModelsMultiSelect = (props: IProps) => {
  const models = useRecoilValue(equipmentModelsAtom).items
  const options: IOption<IEquipmentModel['id']>[] = useMemo(() => {
    return models.map((m) => ({ title: m.name, value: m.id }))
  }, [models])

  return (
    <MultiDropdown
      options={options as any}
      onSelect={props.onSelect}
      title={props.title || 'Выберите модели'}
      selectedOptions={props.selected as any}
      name={props.name}
      panelStyle={props.panelStyle}
      type={props.type || 'input'}
    />
  )
}

export default EquipmentModelsMultiSelect
